import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { log } from '@/logger/logger';
import { FolderScope } from '@/enums/folder-scope.enum';

const logger = log.getLogger('folders');

interface ScopedNavigation {
  currentFolderId: string | null;
}

interface FoldersNavigationState {
  personal: ScopedNavigation;
  workspace: ScopedNavigation;
}

interface FoldersNavigationActions {
  setCurrentFolderId: (folderId: string | null, scope: FolderScope) => void;
  reset: () => void;
}

export type FoldersStore = FoldersNavigationState & FoldersNavigationActions;

const createInitialNavigation = (): ScopedNavigation => ({
  currentFolderId: null,
});

export const useFoldersStore = create<FoldersStore>()(
  devtools(
    (set) => ({
      personal: createInitialNavigation(),
      workspace: createInitialNavigation(),

      setCurrentFolderId: (folderId: string | null, scope: FolderScope) => {
        const scopeKey = scope === FolderScope.PERSONAL ? 'personal' : 'workspace';
        logger.debug(`Navigating to ${scopeKey} folder:`, { folderId });
        set((state) => ({
          [scopeKey]: { ...state[scopeKey], currentFolderId: folderId },
        }));
      },

      reset: () => {
        set(() => ({
          personal: createInitialNavigation(),
          workspace: createInitialNavigation(),
        }));
      },
    }),
    {
      name: 'Folders store',
      enabled: import.meta.env.DEV,
    },
  ),
);
